module.exports = __webpack_public_path__ + "frontend/images/cards/gold/visual-bg@2.jpg?36f4ddd7585b9cda9c618e9266bcbd1b";